// extracted by mini-css-extract-plugin
export default {"primary":"#4698cb","activity-meter":"#4698cb","activity-house":"#51c76d","activity-energy":"#57c4c7","activity-solar":"#fe9e43","activity-battery":"#57c4c7"};